import { getScrollParent } from './getScrollParent'
import { type ScrollElementOptions, scrollElementInternal } from './scrollIntoView'

/**
 * Scroll in `element`'s scroll-parent to move `element` to the top of the
 * screen.
 *
 * If a sticky header is known to be included in a parent, mark that parent with
 * `data-sticky-header-id` to automatically adjust scroll to this.
 */
export const scrollToTopScrollParent = (element: HTMLElement, options: ScrollElementOptions = {}) => {
	const scrollParent = getScrollParent(element)

	if (!scrollParent) {
		throw new Error('Failed to identify scroll parent')
	}

	scrollElementInternal(element, scrollParent.scrollElement, 'scrollToTop', options)
}
